<template>
    <div class="collate-title-bar clearfix">
        <span class="collate-title eight">八字起盘</span>
        <span class="collate-title six" @click="clickSix">六爻起卦</span>
        <div class="collate-type">
            <span class="cur">输入时间</span>
            <span @click="clickAdvanced('sizhu')">四柱</span>
            <!-- <span class="hide">万年历</span> -->
        </div>
    </div>
</template>

<script>
import { DOM } from '../../modules/dom'
import { MIX } from '../../modules/utils';
export default {
    name: 'CollateTitleBar',
    methods:{
        clickSix() {
            MIX.trackButtonClicked('home_liuyao');
            this.$store.dispatch('activity/resetActivityData');
            this.$router.replace('/diagram');
        },
        clickAdvanced(type) {
            if(type == 'sizhu') {
                MIX.trackButtonClicked('home_sizhu');
            }
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/collate/advancedcollate');
            DOM.hidePageByClassName('collate-page');
        }
    }
}
</script>